import './App.css';
import AdiShivShaktiWebsite from './pages/AdiShivShaktiWebsite';
// import ComingSoon from './pages/ComingSoon';

function App() {
  return (
    <AdiShivShaktiWebsite />
  );
}

export default App;
